import { Skull } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer className="relative border-t-4 border-crimson bg-void newsprint-grain overflow-hidden">
      <div className="absolute inset-0 halftone opacity-[0.06] pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 pt-20 pb-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/covers/atrocity-logo.webp" alt="Atrocity Comix logo" className="h-8 w-8 rounded-full" />
              <span className="font-marker text-yell text-sm -rotate-2">FEARLESS SINCE 2018</span>
            </div>
            <p className="font-type text-sm text-paper/50 max-w-sm leading-relaxed">
              Gothic horror comix starring the bad girls your mamma warned you about.
              Physical, digital, and utterly uncensored.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              ["Story", "#story"],
              ["Titles", "#titles"],
              ["Art", "#gallery"],
              ["Contact", "#contact"],
            ].map(([label, href]) => (
              <button
                key={href}
                data-testid={`footer-${label.toLowerCase()}-link`}
                onClick={() => scrollToId(href)}
                className="font-impact uppercase text-xs tracking-widest text-paper/60 transition-colors duration-150 hover:text-crimson"
              >
                {label}
              </button>
            ))}
            <a
              data-testid="footer-terms-link"
              href="/terms"
              className="font-impact uppercase text-xs tracking-widest text-paper/60 transition-colors duration-150 hover:text-crimson"
            >
              Terms
            </a>
            <a
              data-testid="footer-privacy-link"
              href="/privacy"
              className="font-impact uppercase text-xs tracking-widest text-paper/60 transition-colors duration-150 hover:text-crimson"
            >
              Privacy
            </a>
          </nav>
          <span className="inline-block bg-blooddeep text-white font-marker text-sm px-4 py-2 rotate-2 ink-shadow-sm self-start md:self-auto">
            18+ — SHE BITES
          </span>
        </div>

        <h2 className="font-display text-[12vw] leading-none text-center select-none">
          <span className="text-paper">ATROCITY</span>{" "}
          <span className="text-crimson">COMIX</span>
        </h2>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-12 pt-6 border-t border-border">
          <p className="font-courier text-[11px] uppercase tracking-widest text-paper/40">
            © 2018 and beyond — Atrocity Comix. All rights reserved.
          </p>
          <p className="font-courier text-[11px] uppercase tracking-widest text-paper/40">
            We don't just publish stories. <span className="text-crimson">We unleash them.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
